import { render } from "./IntegrationsReportingComponent.vue?vue&type=template&id=70f12b43&scoped=true"
import script from "./IntegrationsReportingComponent.vue?vue&type=script&lang=js"
export * from "./IntegrationsReportingComponent.vue?vue&type=script&lang=js"

import "./IntegrationsReportingComponent.vue?vue&type=style&index=0&id=70f12b43&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f12b43"]])

export default __exports__